import $ from "jquery";

/**
 * implements header functionalities like dropdown menu and popup openers
 *
 */
export function initHeader() {
  // logic and listeners here
  const $rootElement = $('header');
  const $dropdownMenuOpener = $('.header__nav-menu .dropdown-link', $rootElement);
  const $mobileMenuToggle = $('.header__top-menu .mobile-nav-toggle', $rootElement);
  const $dropdownMenu = $('.megadropdown', $rootElement);
  const $focusableMenuSiblings = $('.menu-focusable-sibling', $rootElement);

  const menuItems = $('.header__nav-menu .dropdown-link', $rootElement);
  const subMenuItems = $('.dd-menu .fullItemLink', $dropdownMenu);
  const keys = {
    tab: 9,
    enter: 13,
    esc: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40
  }
  let currentIndex = 0;
  let subIndex = 0;

  const handleDropdownMenu = (action, $dropdownElement, $openerElement) => {
    if(action === 'open'){
      $dropdownElement.addClass('opened');
      $dropdownElement.attr('aria-hidden', false);
      $openerElement.attr('aria-expanded', true);
    } else {
      $dropdownElement.removeClass('opened');
      $dropdownElement.attr('aria-hidden', true);
      $openerElement.attr('aria-expanded', false);
    }
  };

  $dropdownMenuOpener.on('mouseenter', ev => {
    const $opener = $(ev.currentTarget);
    if($(window).width() > 768){
      handleDropdownMenu('open', $opener.closest('li').find('.dd-menu'), $opener);
    }
  });

  // keydown event for accessibility
  $dropdownMenuOpener.on('focus', () => {
    // close previously opened dropdown
    let $activeMenu = $rootElement.find('.dd-menu.opened');
    $activeMenu.removeClass('opened');
    $activeMenu.attr('aria-hidden', true);
    $activeMenu.siblings().attr('aria-expanded', false);
  });

  $focusableMenuSiblings.on('focus', () => {
    let $activeMenu = $rootElement.find('.dd-menu.opened');
    $activeMenu.removeClass('opened');
    $activeMenu.attr('aria-hidden', true);
    $activeMenu.siblings().attr('aria-expanded', false);
  });

  $dropdownMenuOpener.on('click', ev => {
    ev.preventDefault();
    const $opener = $(ev.currentTarget);

    if($(window).width() <= 768){
      $opener.closest('li').find('.dd-menu').toggleClass('opened');
      $opener.toggleClass('opened');
      $opener.attr('aria-expanded', ($opener.hasClass('opened') ? true : false));
    } else {
      if ($rootElement.find('.dd-menu.opened').length > 0) {
        $opener.trigger('mouseleave');
      } else {
        $opener.trigger('mouseenter');
      }
    }
  });

  $dropdownMenu.on('mouseleave', ev => {
    const $opener = $(ev.currentTarget).find('.dropdown-link');

    if($(window).width() > 768) {
      handleDropdownMenu('close', $rootElement.find('.dd-menu'), $opener);
    }
  });

  $mobileMenuToggle.on('click', ev => {
    ev.preventDefault();
    const $opener = $(ev.currentTarget);
    $opener.toggleClass('opened');
    $('body').toggleClass('menu-opened');
    $opener.attr('aria-expanded', ($opener.hasClass('opened') ? true : false));
    $rootElement.find('.header__nav-menu').toggleClass('opened');
  });

  //-----------------------------------------Functionality for accessible Menu--------------------------------------------

  /**
   * Sets focus on given index
   * @param {number} idx
   */
  const gotoIndex = idx => {
    if (idx == menuItems.length) {
      idx = 0;
    } else if (idx < 0) {
      idx = menuItems.length - 1;
    }
    menuItems[idx].focus();
    currentIndex = idx;
  }

  /**
   * Sets focus on given index in given menu
   * @param {jQuery} menu
   * @param {number} idx
   * @param {boolean} backOutOfIndex - go to mainMenuItem when index is out of range
   */
  const gotoSubIndex = (menu, idx, backOutOfIndex = false) => {
    let items = menu.parent().find('.dd-menu .fullItemLink');
    if (idx >= items.length) {
      if (backOutOfIndex) {
        gotoIndex(currentIndex);
        return;
      } else {
        idx = 0;
      }
    } else if (idx < 0) {
      if (backOutOfIndex) {
        gotoIndex(currentIndex);
        return;
      } else {
        idx = items.length - 1;
      }
    }
    items[idx].focus();
    subIndex = idx;
  }

  menuItems.each((i, el) => {
    $(el).on('keydown', ev => {
      let prevdef = false;
      switch (ev.keyCode) {
        case keys.right:
          gotoIndex(currentIndex + 1);
          prevdef = true;
          break;
        case keys.left:
          gotoIndex(currentIndex - 1);
          prevdef = true;
          break;
        case keys.tab:
          if (ev.shiftKey) {
            gotoIndex(currentIndex - 1);
          } else {
            gotoIndex(currentIndex + 1);
          }
          prevdef = true;
          break;
        case keys.enter:
        case keys.down:
          $(el).trigger('click');
          subIndex = 0;
          gotoSubIndex($(el), 0);
          prevdef = true;
          break;
        case keys.up:
          $(el).trigger('click');
          subIndex = $(el).parent().find('.dd-menu .fullItemLink').length - 1;
          gotoSubIndex($(el), subIndex);
          prevdef = true;
          break;
        case keys.esc:
          $focusableMenuSiblings.focus();
          prevdef = true;
          break;
      }
      if (prevdef) {
        ev.preventDefault();
      }
    });
  });

  subMenuItems.each((i, el) => {
    $(el).on('keydown', ev => {
      let prevdef = false;
      switch (ev.keyCode) {
        case keys.tab:
          if (ev.shiftKey) {
            gotoIndex(currentIndex - 1);
          } else {
            gotoIndex(currentIndex + 1);
          }
          prevdef = true;
          break;
        case keys.right:
          gotoSubIndex($(el).closest('.megadropdown').find('.dropdown-link'), subIndex + 1);
          prevdef = true
          break;
        case keys.left:
          gotoSubIndex($(el).closest('.megadropdown').find('.dropdown-link'), subIndex - 1);
          prevdef = true
          break;
        case keys.esc:
          gotoIndex(currentIndex);
          prevdef = true;
          break;
        case keys.down:
          gotoSubIndex($(el).closest('.megadropdown').find('.dropdown-link'), subIndex + 3, true);
          prevdef = true
          break;
        case keys.up:
          gotoSubIndex($(el).closest('.megadropdown').find('.dropdown-link'), subIndex - 3, true);
          prevdef = true
          break;
        case keys.enter:
        case keys.space:
          break;
      }
      if (prevdef) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    });
  });
}
